export default __webpack_public_path__ + "static/media/Diviner's Bracers of Consumed Souls.0c547cb7.jpg";